import { z } from 'zod';

import { BaseValidations } from '@anytag/shared-validations';

export const RefreshPasswordSchema = z.object({
  email: BaseValidations.EmailSchema,
  isSuccess: z.boolean()
});
